export default "__VITE_ASSET__D15p84GE__"